import { FC, ReactNode } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

interface AccountFormItemProps {
    element: ReactNode;
    label?: string;
    hint?: string;
    error?: string | null;
    isRequired?: boolean;
}

export const AccountFormItem: FC<AccountFormItemProps> = ({ element, label, hint, error, isRequired }) => (
    <>
        <div>
            {label && (
                <>
                    <Text style="secondary" typography="label-2-regular">
                        {label}
                        {isRequired && ' *'}
                    </Text>
                    <VSpacing default={12} />
                </>
            )}
            {element}
            {hint && !error && (
                <>
                    <VSpacing default={4} />
                    <Text typography="paragraph-3-regular" style="secondary">
                        {hint}
                    </Text>
                </>
            )}
            {error && (
                <>
                    <VSpacing default={4} />
                    <Text typography="paragraph-3-regular" style="negative">
                        {error}
                    </Text>
                </>
            )}
        </div>
        <VSpacing default={32} />
    </>
);
